// © 2026 Camp Promethean, LLC. All Rights Reserved.

export const WAITLIST_GATED_PATHS = [
  "/signup",
  "/solutions",
  "/pricing",
  "/about",
  "/contact",
] as const;

export function isWaitlistCurtainEnabled(): boolean {
  // Vite inlines this at build time. Unset must mean ON: Vercel does not
  // load repo-root .env.local, so requiring === "true" shipped the marketing
  // site to camppro.io. Set VITE_WAITLIST_CURTAIN=false and redeploy to lift.
  return import.meta.env.VITE_WAITLIST_CURTAIN !== "false";
}

export function isWaitlistGatedPath(pathname: string): boolean {
  return WAITLIST_GATED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
